import Wrapper from "../../../layout/Wrapper";
import VehicleContractReportComponent from "../../../screens/reports/vehicleContract";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Vehicle Contract Report",
	description: "",
};

export default function VehicleContractReport() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<VehicleContractReportComponent />
		</Wrapper>
	);
}